import { Bot } from 'lucide-react';
import React, { useState } from 'react';
import BuildBotModal from '../BuildBotModal/BuildBotModal';
import Button from '../Button/Button';

interface BuildButtonProps {}

function BuildBotButton(): React.ReactElement {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const handleOpenModal = (): void => {
    setModalOpen(true);
  };

  const handleCloseModal = (): void => {
    setModalOpen(false);
  };

  return (
    <>
      <Button onClick={handleOpenModal} icon={<Bot size={16} />}>
        Build bot
      </Button>
      <BuildBotModal open={modalOpen} onClose={handleCloseModal} />
    </>
  );
}

export default BuildBotButton;
